export default __webpack_public_path__ + "static/media/figuremap21.1072a677.png";